// extracted by mini-css-extract-plugin
export var container = "_3z-0";
export var icon = "_3z-1";
export var text = "_3z-2";